
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.233 18c8.68 0 13.427-6.925 13.427-12.929 0-.196-.005-.392-.014-.587A9.412 9.412 0 0023 2.13a9.697 9.697 0 01-2.71.715A4.596 4.596 0 0022.365.333a9.682 9.682 0 01-2.996 1.103A4.802 4.802 0 0015.924 0c-2.606 0-4.72 2.035-4.72 4.544 0 .356.042.703.123 1.036-3.922-.19-7.4-1.998-9.726-4.748a4.4 4.4 0 00-.64 2.284c0 1.576.834 2.968 2.1 3.783A4.823 4.823 0 01.924 6.33v.058c0 2.2 1.626 4.038 3.785 4.454a4.89 4.89 0 01-2.131.079c.6 1.805 2.343 3.119 4.408 3.156a9.702 9.702 0 01-5.86 1.945C.745 16.022.369 16 0 15.959A13.735 13.735 0 007.233 18z"}})])
          )
        }
      }
    